import React, { createContext, useContext, useState, ReactNode } from "react";

interface BreadcrumbsContentContextType {
  content: ReactNode | null;
  setContent: (content: ReactNode | null) => void;
}

const BreadcrumbsContentContext = createContext<
  BreadcrumbsContentContextType | undefined
>(undefined);

export const BreadcrumbsContentProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [content, setContent] = useState<ReactNode | null>(null);

  return (
    <BreadcrumbsContentContext.Provider value={{ content, setContent }}>
      {children}
    </BreadcrumbsContentContext.Provider>
  );
};

export const useBreadcrumbsContent = () => {
  const context = useContext(BreadcrumbsContentContext);
  if (!context) {
    throw new Error(
      "useBreadcrumbsContent must be used within BreadcrumbsContentProvider"
    );
  }
  return context;
};
